import { bi } from "@/lib/i18n";

const EXPERIENCE_KEYS = ["schoolProjects", "competitions", "internships", "workExperience", "volunteering", "leadership"];

// Returns the checklist an admissions advisor would expect before a CV is "application-ready".
export function computeCompletion(cv, lang) {
  const cats = cv?.categories || {};
  const p = cv?.personal || {};
  const has = (k) => (cats[k] || []).length > 0;
  const items = [
    { key: "fullName", step: "personal", ok: !!p.fullName, label: { tr: "Ad Soyad", en: "Full name" } },
    { key: "photo", step: "personal", ok: !!p.photoUrl, label: { tr: "Vesikalık fotoğraf", en: "Passport photo" } },
    { key: "targetProgram", step: "personal", ok: !!bi(p.targetProgram, lang), label: { tr: "Hedef program / bölüm", en: "Target program" } },
    { key: "education", step: "education", ok: has("education"), label: { tr: "Eğitim geçmişi", en: "Education" } },
    { key: "languages", step: "languages", ok: has("languages"), label: { tr: "Yabancı dil bilgisi", en: "Languages" } },
    { key: "digitalSkills", step: "digitalSkills", ok: has("digitalSkills"), label: { tr: "Dijital yetkinlikler", en: "Digital skills" } },
    { key: "hobbies", step: "hobbies", ok: has("hobbies"), label: { tr: "Hobiler ve ilgi alanları", en: "Hobbies & interests" } },
    {
      key: "experience", step: "schoolProjects", ok: EXPERIENCE_KEYS.some(has),
      label: { tr: "En az bir deneyim (proje, yarışma, staj, gönüllülük, liderlik)", en: "At least one experience (project, competition, internship, volunteering, leadership)" },
    },
    { key: "consents", step: "consents", ok: !!cv?.consents?.formSubmission, label: { tr: "KVKK açık rıza onayı", en: "Data-protection consent" } },
  ];
  const done = items.filter((i) => i.ok).length;
  return { items, missing: items.filter((i) => !i.ok), done, total: items.length, pct: Math.round((done / items.length) * 100) };
}
